var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"textfield",attrs:{"rules":[val => _vm.$validator.phone(_vm.getValidatorVal(), _vm.$attrs.label)],"value":_vm.value,"dense":"","outlined":""},on:{"input":_vm.valueChanged}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }